var exports = {
  "DR": "Box_0__PJE7rR",
  "wy": "Box_1__8AM9PD",
  "pv": "Box_2__YWNumx",
  "w9": "Box_3__zd-a3i",
  "pQ": "Box_4__Msc0n6",
  "hq": "nonEmpty__yokGQs",
  "a3": "Button_0__Ij17DU",
  "EE": "standaloneButton__CvgowA",
};

module.exports = exports;
